// Strip "[HD]" tags and "| RetroGameUp" trailers, collapse whitespace.
export function cleanTitle(raw: string | null | undefined): string {
  if (!raw) return '';
  return raw
    .toString()
    .replace(/\[HD\]/gi, '')
    .replace(/\|\s*RetroGameUp/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// URL-safe slug. Mirrors the original site's algorithm so existing inbound
// links keep resolving.
export function slugify(s: string): string {
  return cleanTitle(s)
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-');
}

// Parse a YouTube ISO-8601 duration ("PT1H23M45S") to total seconds.
export function isoDurationToSeconds(iso: string | null | undefined): number {
  if (!iso) return 0;
  const m = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
  if (!m) return 0;
  const h = parseInt(m[1] || '0', 10);
  const min = parseInt(m[2] || '0', 10);
  const s = parseInt(m[3] || '0', 10);
  return h * 3600 + min * 60 + s;
}
